import { combineReducers } from 'redux'

import {
  SELECT_DATE,
  SELECT_TIDE_STATION,
  CLEAR_SELECTED_TIDE_STATION,
  UPDATE_NOW_MOMENT,
  SET_PAGE_VIEW,
  PAGE_VIEWS,
  UPDATE_LOCATION_SEARCH,
  OPEN_DATE_PICKER,
  CLOSE_DATE_PICKER,
} from '../actions'






// ============
// = Reducers =
// ============

function selectedTideStation(state=null, action) {
  switch (action.type) {
  case SELECT_TIDE_STATION:
    return action.station
  case CLEAR_SELECTED_TIDE_STATION:
    return null
  default:
    return state
  }
}

function visitedTideStations(state=[], action) {
  if (action.type === SELECT_TIDE_STATION) {
    const selectedStation = action.station
    const newState = state.slice()

    // Remove selectedStation from array if it exists
    const index = newState.findIndex(s => {
      return s.stationId === selectedStation.stationId
    })
    if (index !== -1) {
      newState.splice(index, 1)
    }
    newState.unshift(selectedStation)
    return newState
  }
  return state
}

function selectedDate(state=null, action) {
  if (action.type === SELECT_DATE) {
    return action.date
  }
  return state
}

function datePickerIsOpen(state=false, action) {
  switch (action.type) {
  case OPEN_DATE_PICKER:
    return true
  case CLOSE_DATE_PICKER:
    return false
  default:
    return state
  }
}

function now(state=null, action) {
  if (action.type === UPDATE_NOW_MOMENT) {
    return action.now
  }
  return state
}

function locationSearch(
  state={
    query: '',
    hasFocus: false,
  },
  action
) {
  switch (action.type) {
  case UPDATE_LOCATION_SEARCH:
    return {
      ...state,
      ...action.locationSearchProps
    }
  default:
    return state
  }
}


const initPageView = process.env.REACT_APP_INIT_PAGE_VIEW || PAGE_VIEWS.DAY_PAGE
function pageView(state=initPageView, action) {
  if (action.type === SET_PAGE_VIEW) {
    return action.pageView
  }
  return state
}

export default combineReducers({
  selectedTideStation,
  visitedTideStations,
  selectedDate,
  now,
  pageView,
  locationSearch,
  datePickerIsOpen,
})







// =============
// = Selectors =
// =============

export function nowSelector(state) {
  return state.ui.now
}

export function dateSelector(state) {
  return state.ui.selectedDate
}

export function tideStationSelector(state) {
  return state.ui.selectedTideStation
}

export function visitedTideStationsSelector(state) {
  return state.ui.visitedTideStations
}

export function pageViewSelector(state) {
  return state.ui.pageView
}

export function locationSearchQuerySelector(state) {
  return state.ui.locationSearch.query
}

export function locationSearchHasFocusSelector(state) {
  return state.ui.locationSearch.hasFocus
}

export function datePickerIsOpenSelector(state) {
  return state.ui.datePickerIsOpen
}



// WEBPACK FOOTER //
// ./src/reducers/uiReducer.js